// =============================
// common / preview size
// =============================

export function initPreviewSize() {

    let $preview_panel = $('.s-previewInner');
    let $bodyH = $('.s-preview_body');
    let previewHeader = $('.s-preview_head').outerHeight();
    let winH = $(window).height();
    let winW = $(window).width();
    let headerH = $('.l-h').outerHeight();
    let scTop = $(window).scrollTop();
    let sideFixedRelease = scTop < headerH;

    if (winW > 500 && winH > 500) {
        sideFixedRelease === true ? $preview_panel.css('height', winH - headerH + scTop - 47) : $preview_panel.css('height', winH - 20);
        $bodyH.css('height', $preview_panel.height() - previewHeader - 22);

        $(window).on('resize', function () {
            return winH = $(window).height();
        })

        $(window).on('load resize scroll', function () {
            scTop = $(window).scrollTop();
            sideFixedRelease = scTop < headerH;
            sideFixedRelease === true ? $preview_panel.css('height', winH - headerH + scTop - 47) : $preview_panel.css('height', winH - 20);
            $bodyH.css('height', $preview_panel.height() - previewHeader - 22);
        });
    }

}
